import { useEffect, useState } from 'react';
import * as BsIcons from 'react-icons/bs';
import * as CgIcons from 'react-icons/cg';
import { useLocation, useNavigate } from 'react-router-dom';
import TbhLogoWithText from '../../common/TbhLogoWithText';
import PaymentModal from '../../components/global/PaymentGatewayModal';
import { registerNetcoreActivity } from '../../utils/registerActivity';
import ReactGA from 'react-ga4';
import { dashboardPageUrl } from '../../utils/constants';
import { useAppSelector } from '../../app/hooks';
import jwtDecode from 'jwt-decode';

const iconStyle = { color: '#028789', width: '50px', height: '50px' };
const iconDangerStyle = { color: 'red', width: '50px', height: '50px' };

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function EntrepreneurStatusPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const details = useAppSelector((state) => state.auth.loggedInUserDetails);
  const token: any = localStorage.getItem('login-token');

  const userDeets: any = jwtDecode(token);

  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);

  let paymentStatus: string | undefined;

  const statusQuery = location.search;
  if (statusQuery && statusQuery.startsWith('?status='))
    paymentStatus = statusQuery.slice(1).replace('status=', '');

  useEffect(() => {
    if (!statusQuery.startsWith('?status=')) {
      navigate('/');
      return;
    }

    if (paymentStatus === 'success') {
      registerNetcoreActivity(
        {
          emailAddress: details?.email,
          firstName: details?.firstName,
          lastName: details?.lastName,
          mobileNumber: details?.phoneNumber,
        },
        'TBH_BUSINESS_REGISTRATION_SUCCESSFUL_PAYMENT',
      );

      ReactGA.event({
        category: 'formSubmit',
        action: 'TBH_BUSINESS_REGISTRATION_SUCCESSFUL_PAYMENT',
        label: 'Payment Success',
      });

      const surveyURL = `https://sterlingbank.eu.qualtrics.com/jfe/form/SV_3W9QfSKKG1EtXzo?Q_CHL=si_appsdk&RecipientFirstName=${
        details?.firstName
      }&Phone_no=${details?.phoneNumber}&RecipientEmail=${encodeURIComponent(
        details?.email,
      )}&account_no=${userDeets?.accountNumber}&Gender=${details?.gender}&CustomerAge=${
        userDeets?.customerAge
      }&Location=${details?.country}`;

      window.open(surveyURL, '_blank');
    } else if (paymentStatus === 'failed') {
      registerNetcoreActivity(
        {
          emailAddress: details?.email,
          firstName: details?.firstName,
          lastName: details?.lastName,
          mobileNumber: details?.phoneNumber,
        },
        'TBH_BUSINESS_REGISTRATION_FAILED_PAYMENT',
      );

      ReactGA.event({
        category: 'formSubmit',
        action: 'TBH_BUSINESS_REGISTRATION_FAILED_PAYMENT',
        label: 'Payment Failed',
      });
    }
  }, [navigate, statusQuery, paymentStatus, details]);

  const clicc = () => {
    window.localStorage.setItem('payment-success', 'true');
    window.dispatchEvent(new Event('storage'));
    window.close();

    registerNetcoreActivity(
      {
        emailAddress: details?.email,
        firstName: details?.firstName,
        lastName: details?.lastName,
        mobileNumber: details?.phoneNumber,
      },
      'TBH_BUSINESS_REGISTRATION_SUCCESSFUL_PAYMENT',
    );

    // registerNetcoreActivity(
    //     {
    //         emailAddress: details?.email,
    //         firstName: details?.firstName,
    //         lastName: details?.lastName,
    //         mobileNumber: details?.phoneNumber,
    //     },
    //     'TBH_BUSINESS_REGISTRATION_SUCCESSFUL',
    // );

    ReactGA.event({
      category: 'formSubmit',
      action: 'TBH_BUSINESS_REGISTRATION_SUCCESSFUL',
      label: 'TBH_BUSINESS_REGISTRATION_SUCCESSFUL',
      // value: 1
    });
    setTimeout(() => {
      window.open(`${dashboardPageUrl}/dashboard`, '_top');
    });
  };

  function handleClick(): void {
    setShow(true);
    // registerNetcoreActivity(
    //     {
    //         emailAddress: details?.email,
    //         firstName: details?.firstName,
    //         lastName: details?.lastName,
    //         mobileNumber: details?.phoneNumber,
    //     },
    //     'TBH_BUSINESS_REGISTRATION_SUCCESSFUL_FAILED',
    // );
  }

  return (
    <>
      <div className='w-full flex flex-col items-center h-screen py-10 px-12'>
        {/* <Link to='/'> */}
        <TbhLogoWithText />
        {/* </Link> */}
        <div className='flex flex-col items-center pt-[20px] w-[270px] sm:w-[400px] h-[300px] mt-[50px] bg-[white]'>
          {paymentStatus === 'success' ? (
            <BsIcons.BsCheck2Circle style={iconStyle} />
          ) : (
            <CgIcons.CgDanger style={iconDangerStyle} />
          )}
          <section className='mt-[40px] font-Poppins font-semibold text-base sm:text-lg'>
            {paymentStatus === 'success' ? 'Your payment was successful' : 'Your payment failed'}
          </section>
          {
            paymentStatus === 'success' ? (
              <div
                onClick={() => {
                  clicc();
                  // registerNetcoreActivity(
                  //     {
                  //         emailAddress: details?.email,
                  //         firstName: details?.firstName,
                  //         lastName: details?.lastName,
                  //         mobileNumber: details?.phoneNumber,
                  //     },
                  //     'TBH_BUSINESS_REGISTRATION_SUCCESSFUL_PAYMENT',

                  // );
                }}
              >
                <button className='w-[200px] h-[60px] bg-[#028789] text-white font-Poppins font-normal text-xl rounded-md mt-[40px]'>
                  Proceed
                </button>
              </div>
            ) : // <Link to='/'>
            !loading ? (
              <button
                onClick={() => {
                  handleClick();
                  // registerNetcoreActivity(
                  //     {
                  //         emailAddress: details?.email,
                  //         firstName: details?.firstName,
                  //         lastName: details?.lastName,
                  //         mobileNumber: details?.phoneNumber,
                  //     },
                  //     'TBH_BUSINESS_REGISTRATION_SUCCESSFUL_FAILED',
                  // );
                }}
                className='w-[200px] h-[60px] bg-[#028789] text-[white] font-Poppins font-normal text-xl rounded-md mt-[40px]'
              >
                Try Again
              </button>
            ) : (
              <button className='w-[200px] h-[60px] bg-[#028789] text-[white] font-Poppins font-normal text-xl rounded-md mt-[40px]'>
                Please wait...
              </button>
            )
            // </Link>
          }
        </div>
      </div>

      <PaymentModal show={show} setShow={setShow} />
    </>
  );
}

export default EntrepreneurStatusPage;
